module.exports = __webpack_public_path__ + "img/girl.36ca16a3.png";